
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicTicketCollectionTicketsApi extends BaseModulePublicApi {
  basePath = 'tickets_collections';

  constructor(domain: string, ticket_collection_id: string, token?: string) {
    super(domain, token);
    this.basePath = `${this.basePath}/${ticket_collection_id}/tickets`;
  }
};
